import type { Media } from '@/payload-types'

const GENERIC_ALT =
  /^(imagem|image|photo|foto|picture|img|untitled|figura|figure|grafico|gráfico|screenshot|screen|pic|thumbnail)$/i

/**
 * Alt para SEO / IA: prioriza texto do CMS; evita vazio e rótulos genéricos isolados.
 */
export function resolveMediaImageAlt(resource: Media): string {
  const raw = resource.alt?.trim()
  if (raw && raw.length > 0 && !GENERIC_ALT.test(raw)) {
    return raw
  }
  if (raw && raw.length > 0) {
    return raw
  }

  const base = resource.filename?.replace(/\.[^.]+$/, '') ?? ''
  const fromFile = base
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  if (fromFile.length > 0) {
    const s = fromFile.charAt(0).toUpperCase() + fromFile.slice(1)
    return s
  }

  return 'Ilustração editorial relacionada com o conteúdo'
}
